import ChaPpi from './cha-ppi.es6'
import MelPpi from './mel-ppi.es6'
import ChaPpi2 from './cha-ppi2.es6'
import ChaSgGo from './cha-sg-go.es6'
import ChaSgStopCross from './cha-sg-stop-cross.es6'
import ChaSgStopRed from './cha-sg-stop-red.es6'
import ChaSgThreeChambersDirection from './cha-sg-three-chambers-direction.es6'
import ChaSgThreeChambersPrepare from './cha-sg-three-chambers-prepare.es6'
import ChaSgTwoChambers from './cha-sg-two-chambers.es6'
import MelSgThreeChambersDirection from './mel-sg-three-chambers-direction.es6'
import Ksw from './ksw.es6'
import Ksw2 from './ksw2.es6'
import Elbox from './elbox.es6'
import ControlRelay from './controlrelay.es6'
import PantoAB from './pantoAB.es6'
import PantoBA from './pantoBA.es6'

import Generic from './generic.es6'
import Text from './text.es6'
import Discon from './discon.es6'
import Discon3 from './discon3.es6'
import Heating from './heating.es6'
import Heater from './heater.es6'
import HeatingSystem from './heating-system.es6'
import Mps from './mps.es6'
import Other from './other.es6'
import Pme from './pme.es6'
import Ppi from './ppi.es6'
import Rcont from './rcont.es6'
import Route from './route.es6'
import Sg from './sg.es6'
import TbusSwitch from './tbus-switch.es6'
import TbusTransceiver from './tbus-transceiver.es6'
import Tc from './tc.es6'
import Twc from './twc.es6'
import Vetra from './vetra.es6'
import VoltageFreeLamp from './voltage-free-lamp.es6'
import Zone from './zone.es6'

export default {
  ChaPpi,
  MelPpi,
  ChaPpi2,
  ChaSgGo,
  ChaSgStopCross,
  ChaSgStopRed,
  ChaSgThreeChambersDirection,
  ChaSgThreeChambersPrepare,
  ChaSgTwoChambers,
  MelSgThreeChambersDirection,
  ControlRelay,
  Ksw,
  Ksw2,
  Elbox,
  PantoAB,
  PantoBA,
  Generic,
  Text,
  Discon,
  Discon3,
  Heating,
  Heater,
  HeatingSystem,
  Mps,
  Other,
  Pme,
  Ppi,
  Rcont,
  Route,
  Sg,
  TbusSwitch,
  TbusTransceiver,
  Tc,
  Twc,
  Vetra,
  VoltageFreeLamp,
  Zone
}

// decide where to put device types definitions for frontend
// Visible variables for device detail in visualisation
export const enabledVariables = () => {
  return {
    'TbusSwitch': [
      'actualVehicleNumber',
      'queuedVehicleNumber'
    ],
    'Heating': [
      'airTemp',
      'railTemp',
      'status',
      'emergency'
    ],
    'Discon2': [
      'positionOff',
      'positionOn'
    ],
    'HeatingHostivar': [
      'airTemp',
      'railTemp',
      'roofTemp',
      'status',
      'test',
      'cfgTimeTest',
      'cfgHysteresis',
      'cfgTemperatureCorrectionDry',
      'cfgTemperatureCorrectionWet'
    ],
    'HeatingSystem': [
      'correction',
      'setPoing'
    ]
  }
}
